<template>
	<div tabindex="0" @keyup.esc="closeAdd()" class="hide-outline">
		<TopPanel
			:units="units"
			:pagination="pagination"
			:showCustomer="true"
			:orderBys="orderBys"
			:orderBy="searchParams.orderBy"
			:hide-add="!$isAllowedTo('roles_create')"
			@toggleAdd="toggleAdd"
			@search="search"
			@orderBy="orderBy"
		/>
		<main class="main-view columns" @click="closeAdd()">
			<RoleList
				:roles="roles"
				@delete="askToDelete"
				@edit="editRole"
				@search="getRoles"
			/>
		</main>
		<AddRole
			v-if="showAdd"
			@save="saveRole"
			@cancel="closeAdd"
			:editRole="selectedRole"
		/>
		<DeleteModal
			v-if="showDelete"
			@confirm="deleteSelected"
			@cancel="cancelDelete"
			:message="deleteMessage"
		/>
	</div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import RoleList from './components/RoleList';
import AddRole from './modals/AddRole';
import DeleteModal from '@/components/DeleteModal';
import TopPanel from '@/components/TopPanel';

export default {
	components: {
		RoleList,
		AddRole,
		DeleteModal,
		TopPanel
	},
	data() {
		return {
			showAdd: false,
			showDelete: false,
			selectedRole: {},
		};
	},
	computed: {
		...mapState('roleStore', ['searchParams']),
		...mapGetters('roleStore', ['roles', 'pagination']),
		...mapGetters('appStore', ['isMobile']),
		...mapGetters('user', ['getActiveCustomer']),
		deleteMessage() {
			return this.selectedRole.name
				? this.$t('rolesview.delete_confirmation', { name: this.selectedRole.name })
				: '';
		},

		orderBys() {
			return [
				{ name: this.$t('roundplanningview.order_by_name'), value: 'Name' },
				{ name: this.$t('roundplanningview.order_by_created'), value: 'Created' }
			];
		},
		units() {
			return [
				this.$t('rolesview.unit_singular'),
				this.$t('rolesview.unit_plural'),
				this.$t('rolesview.new_button')
			];
		}

	},
	watch: {
		'getActiveCustomer.id'(to) {
			this.searchParams.customerId = to;
			this.getRoles();
		}
	},
	methods: {
		...mapActions('roleStore', [
			'getRoles',
			'createRole',
			'updateRole',
			'deleteRole'
		]),

		toggleAdd() {
			if (!this.$isAllowedTo('roles_create')) return;

			if (!this.selectedRole.firstName) {
				this.showAdd = !this.showAdd;
			}

			this.selectedRole = {};
		},

		closeAdd() {
			if (window.getSelection().toString() == '') {
				this.selectedRole = {};
				this.showAdd = false;
			}

			if (this.showDelete) {
				this.showDelete = false;
				this.selectedRole = {};
			}
		},

		saveRole(role) {
			const capability = this.selectedRole.id ? 'roles_edit' : 'roles_create';
			if (!this.$isAllowedTo(capability)) return;

			if (this.selectedRole.id) {
				this.updateRole(role).then(() => {
					this.showAdd = false;
					this.selectedRole = {};
				});
			} else {
				role.customerId = this.getActiveCustomer?.id;
				this.createRole(role).then(() => {
					this.showAdd = false;
				});
			}
		},

		editRole(role) {
			if (!this.$isAllowedTo('roles_edit')) return;

			if (this.selectedRole == role) {
				this.selectedRole = {};
				this.showAdd = false;
			} else {
				this.selectedRole = role;
				this.showAdd = true;
			}
		},

		askToDelete(role) {
			if (!this.$isAllowedTo('roles_delete')) return;

			this.showAdd = false;
			Object.assign(this.selectedRole, role);
			this.showDelete = true;
		},

		cancelDelete() {
			this.showDelete = false;
			this.selectedRole = {};
		},

		deleteSelected() {
			if (!this.$isAllowedTo('roles_delete')) return;

			this.deleteRole(this.selectedRole).then(() => {
				this.showDelete = false;
				this.selectedRole = {};
			});
		},

		search(searchValue) {
			this.searchParams.search = searchValue;
			this.getRoles();
		},

		orderBy(orderBy) {
			this.searchParams.orderBy = orderBy;
			this.getRoles();
		}
	},

	created() {
		this.searchParams.customerId = this.getActiveCustomer?.id;
		this.getRoles();
	}
};
</script>
